import { useState, useCallback } from "react";
import {
  type SortOptionKey,
  type SortOptionValue,
  sortOptions,
  isValidSortOption,
} from "../types/sorting";

interface UseSortResult {
  currentSort: SortOptionKey;
  sortValue: SortOptionValue;
  updateSort: (newSort: string) => void;
}

export const useSort = (
  defaultSort: SortOptionKey = "featured",
): UseSortResult => {
  const [currentSort, setCurrentSort] = useState<SortOptionKey>(defaultSort);

  const updateSort = useCallback((newSort: string) => {
    if (isValidSortOption(newSort)) {
      setCurrentSort(newSort);
    }
  }, []);

  return {
    currentSort,
    sortValue: sortOptions[currentSort],
    updateSort,
  };
};
